import { render, staticRenderFns } from "./UserReportSeriesNumbersList.vue?vue&type=template&id=640b765b"
import script from "./UserReportSeriesNumbersList.vue?vue&type=script&lang=js"
export * from "./UserReportSeriesNumbersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports